<template>
  <div>
    <mt-popup v-model="show" position="bottom" :closeOnClickModal="false">
      <div class="wrap">
        <div class="title">
          <img class="close" src="@/assets/img/tianjia.png" alt="" @click="popShow" />
          {{ $t("身份验证") }}
        </div>
        <template v-if="info.type === 'all'">
          <div class="item-group" v-if="info.method.includes('email')">
            <div class="label">{{ $t("输入邮箱验证码") }}</div>
            <div class="sub">{{ $t("发送验证码至邮箱") }}</div>
            <div class="value">
              <input v-model="emailCode" type="text" class="input" :placeholder="this.$t('请输入邮箱验证码')" />
              <span v-if="emailCount < 180">{{ emailCount }}s</span>
              <button v-else class="btn" @click="sendCode('email')">
                {{ $t("发送验证码") }}
              </button>
            </div>
          </div>
          <div class="item-group" v-if="info.method.includes('mobile')">
            <div class="label">
              {{ $t("输入手机验证码") }}
            </div>
            <div class="sub">{{ $t("发送验证码至手机") }}</div>
            <div class="value">
              <input v-model="mobileCode" type="text" class="input" :placeholder="$t('请输入手机验证码')" />
              <span v-if="mobileCount < 180">{{ mobileCount }}s</span>
              <button v-else class="btn" @click="sendCode('mobile')">
                {{ $t("发送验证码") }}
              </button>
            </div>
          </div>
          <div class="item-group" v-if="info.method.includes('google')">
            <div class="label">{{ $t("输入谷歌验证码") }}</div>
            <div class="value">
              <input v-model="googleCode" type="text" class="input" :placeholder="$t('请输入谷歌验证码')" />
            </div>
          </div>
        </template>
        <template v-if="info.type === 'or'">
          <div class="item-group" v-show="activeMethod === 'email'">
            <div class="label">{{ $t("输入邮箱验证码") }}</div>
            <div class="sub">{{ $t("发送验证码至邮箱") }}</div>
            <div class="value">
              <input v-model="emailCode" type="text" class="input" :placeholder="$t('请输入邮箱验证码')" />
              <span v-if="emailCount < 180">{{ emailCount }}s</span>
              <button v-else class="btn" @click="sendCode('email')">
                {{ $t("发送验证码") }}
              </button>
            </div>
          </div>
          <div class="item-group" v-show="activeMethod === 'mobile'">
            <div class="label">{{ $t("输入手机验证码") }}</div>
            <div class="sub">{{ $t("发送验证码至手机") }}</div>
            <div class="value">
              <input v-model="mobileCode" type="text" class="input" :placeholder="this.$t('请输入手机验证码')" />
              <span v-if="mobileCount < 180">{{ mobileCount }}s</span>
              <button v-else class="btn" @click="sendCode('mobile')">
                {{ $t("发送验证码") }}
              </button>
            </div>
          </div>
          <div class="item-group" v-show="activeMethod === 'google'">
            <div class="label">{{ $t("输入谷歌验证码") }}</div>
            <div class="value">
              <input v-model="googleCode" type="text" class="input" :placeholder="this.$t('请输入谷歌验证码')" />
            </div>
          </div>
        </template>
        <div class="ft-bar">
          <button class="btn" @click="onVerifyCode">{{ $t("立即验证") }}</button>
          <template v-if="info.type === 'or'">
            <button class="btn inset" v-if="activeMethod !== 'email'" @click="activeMethod = 'email'">
              {{ $t("邮箱验证") }}
            </button>
            <button class="btn inset" v-if="activeMethod !== 'mobile'" @click="activeMethod = 'mobile'">
              {{ $t("手机验证") }}
            </button>
            <button class="btn inset" v-if="activeMethod !== 'google'" @click="activeMethod = 'google'">
              {{ $T("谷歌验证") }}
            </button>
          </template>
        </div>



      </div>

    </mt-popup>
    <ImageVerify :scene="scene" :username="nametype == 'email' ? userInfo.user_email : userInfo.mobile" ref="imageverify"
      @imageCallback="imageCallback"></ImageVerify>
  </div>
</template>

<script>
import { httpGetVerifyMethod, httpGetOperateCredentials } from "@/api/index";
import ImageVerify from "@/components/ImageVerify.vue";
import { httpGetCode } from "@/api/userCenter";
import { Toast } from "mint-ui";
import { mapState } from "vuex";
export default {
  components: { ImageVerify },
  props: {
    scene: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      show: false,
      activeMethod: "",
      info: {},
      //全部
      emailCode: "",
      mobileCode: "",
      googleCode: "",
      emailCount: 180,
      mobileCount: 180,

      nametype: "", //传递username标识
    };
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.userInfo,
    }),
  },
  activated() {
  },
  emits: ["onVerify"],
  watch: {
    show(value) {
      this.getMethod();
      if (value && this.info.type === "none") {
        this.onVerifyCode();
      }
      if (!value) {
        this.activeMethod = "";
        this.emailCode = "";
        this.mobileCode = "";
        this.googleCode = "";
        this.emailCount = 180;
        this.mobileCount = 180;
        this.nametype = ''
      }
    },
  },
  methods: {
    getMethod() {
      // 操作凭证验证类型    scene传值 credentials_withdraw=提币
      httpGetVerifyMethod({ scene: this.scene }).then(({ data }) => {
        this.info = data;
        if (data.type === "or") {
          // or验证方式任选其一
          this.activeMethod = data.method[0];
        }
      });
    },

    popShow() {
      // 所有弹框公用状态
      this.show = false;

      // 针对谷歌验证其开发状态特别加入
      this.$emit("SwitchControll");
    },
    // 点击验证
    onVerifyCode() {
      const payload = { scene: this.scene };
      if (this.info.type === "or") {
        if (this.activeMethod === "email") {
          if (!this.emailCode) {
            Toast("请输入验证码");
            return false;
          }
          payload.email_code = this.emailCode;
        } else if (this.activeMethod === "mobile") {
          if (!this.mobileCode) {
            Toast(this.$t("请输入验证码"));
            return false;
          }
          payload.mobile_code = this.mobileCode;
        } else {
          if (!this.googleCode) {
            Toast(this.$t("请输入验证码"));
            return false;
          }
          payload.google_code = this.googleCode;
        }
      } else if (this.info.type === "all") {
        if (this.info.method.includes("email")) {
          if (!this.emailCode) {
            Toast("请输入邮箱验证码");
            return false;
          }
          payload.email_code = this.emailCode;
        }
        if (this.info.method.includes("mobile")) {
          if (!this.mobileCode) {
            Toast(this.$t("请输入手机验证码"));
            return false;
          }
          // else if (this.mobileCount == 180) {
          //   Toast("请先发送验证码");
          //   return false;
          // }
          payload.mobile_code = this.mobileCode;
        }
        if (this.info.method.includes("google")) {
          if (!this.googleCode) {
            Toast(this.$t("请输入谷歌验证码"));
            return false;
          }
          payload.google_code = this.googleCode;
        }
      }
      // 获取操作凭证
      httpGetOperateCredentials(payload).then((res) => {
        this.show = false;
        this.$emit("onVerify", res.data);
      });
    },

    // 点击发送验证码
    sendCode(method) {
      // 发送验证码接口
      this.nametype = method
      // 图片验证
      this.$refs.imageverify.run()
      // this.username = "method === 'email' ? this.userInfo.user_email : this.userInfo.mobile,"
      // httpGetCode({
      //   scene: this.scene,
      //   username:
      //     method === "email" ? this.userInfo.user_email : this.userInfo.mobile,
      // }).then((res) => {
      //   Toast(res.msg);
      //   this.countDown(method);
      // });
    },

    imageCallback() {
      this.countDown(this.nametype);

    },
    countDown(method) {
      if (method === "email") {
        const emailTimer = setInterval(() => {
          this[method + "Count"]--;
          if (this[method + "Count"] === 0) {
            clearInterval(emailTimer);
            this[method + "Count"] = 180;
          }
        }, 1000);
      } else {
        const mobileTimer = setInterval(() => {
          this[method + "Count"]--;
          if (this[method + "Count"] === 0) {
            clearInterval(mobileTimer);
            this[method + "Count"] = 180;
          }
        }, 1000);
      }
    },
  },
};
</script>

<style scoped lang="less">
.wrap {
  width: 100vw;
  height: 100vh;
  padding: 20px;
  box-sizing: border-box;

  .title {
    position: relative;
    text-align: center;
    line-height: 24px;
    margin-bottom: 20px;
  }

  .title .close {
    position: absolute;
    left: 0;
    top: 2px;
    width: 20px;
    transform: rotate(45deg);
  }
}

.item-group {
  padding: 20px 0;

  .sub {
    font-size: 12px;
    opacity: 0.8;
    margin-top: 5px;
  }

  .value {
    margin-top: 15px;
    box-shadow: 0px 5px 15px 0px rgba(0, 0, 0, 0.1);
    border-radius: 15px;
    display: flex;
    align-items: center;
    height: 44px;

    .input {
      flex: 1;
      margin: 0 15px;
    }

    .btn {
      flex-shrink: 0;
      padding: 0 15px;
      background-color: transparent;
      color: #1b85d7;
      font-size: 13px;
    }

    span {
      flex-shrink: 0;
      padding: 0 15px;
      font-size: 13px;
    }
  }
}

.ft-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 10px 20px;
  box-sizing: border-box;

  .btn {
    display: block;
    width: 100%;
    height: 40px;
    box-sizing: border-box;
    border-radius: 20px;
    color: #fff;
    background-color: #1b85d7;
    border: 1px solid #1b85d7;
    margin: 10px 0;

    &.inset {
      background-color: #fff;
      color: #1b85d7;
    }
  }
}
</style>
